import React from 'react';
import './index.css';
import App from './App';
import ReactDOM from "react-dom/client";
import { Analytics } from '@vercel/analytics/react';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>,
);


